import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import store from '@store/store';
import { loginService } from '@core/services';

import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

loginService.currentUser();

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
registerServiceWorker();
